<template lang="pug">
.card.mt-3
	.card-header.bg-dark.text-white
		span.fa.fa-star.mr-2
		| Palabras clave
	.card-body
		button.btn.btn-warning.btn-sm.m-1(
			v-for="palabra in palabras"
			:key="palabra[0]"
		) {{palabra[0]}} ({{palabra[1]}})
</template>

<script>
export default {
	props: ['palabrasClave'],
	computed: {
		palabras () {
			const arr = Array.from(this.palabrasClave)
			arr.sort((a, b) => {
				if (a[1] > b[1]) {
					return -1
				} else if (a[1] === b[1]) {
					return 0
				} else {
					return 1
				}
			})
			return arr.slice(0, 10)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/palabrasClave.vue